import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import { UserState } from 'state/user/UserReducer';
import { AssetState } from './assets/AssetReducer';
import { UsersState } from 'state/users/UsersReducer';
import { QueryState } from 'state/query/QueryReducer';

export interface AppState {
   currentUser: UserState;
   currentAssets: AssetState;
   requestedPathname: string;
   users: UsersState;
   query: QueryState;
}

export const configureStore = (preloadedState = {}) => {
   const middleware = [thunk];
   const middlewareEnhancer = applyMiddleware(...middleware);
   const composedEnhancers = composeWithDevTools(...[middlewareEnhancer]);
   return createStore(rootReducer, preloadedState, composedEnhancers);
};
